const MICROSOFT_BTN_COOKIE_NAMES = [
    'showMicrosoftBtnGroup',
];

const ENABLED_COOKIE_VALUES = ['true', '1', 'yes'];

const getCookieValue = (name: string): string => {
    const escapedName = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
    const matchedCookie = document.cookie.match(new RegExp(`(?:^|; )${escapedName}=([^;]*)`));
    return matchedCookie ? decodeURIComponent(matchedCookie[1]) : '';
};

/** Microsoft OAuth buttons are gated behind a cookie for gradual rollout. */
export const shouldShowMicrosoftButtonGroup = (): boolean => {
    return MICROSOFT_BTN_COOKIE_NAMES.some((cookieName) =>
        ENABLED_COOKIE_VALUES.includes(getCookieValue(cookieName).toLowerCase())
    );
};
